/*
  Mixin used to manage debug mode
*/
export default  {
  computed: {
    debugMode() {
      return this.$store.state.debugMode
    },
  },
};
